export default __webpack_public_path__ + "d8569b9a982f71ed715c16df4e6e464f.png";